import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  TextField,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  TableContainer,
  useMediaQuery,
} from "@mui/material";

import Nav from "../../Components/Nav";

import stakinbg from "../../assets/stakinbg.png";
import Binance from "../../assets/Binance.png";
import discard from "../../assets/discard.png";
import bgframe from "../../assets/bgframe.png";
// import Timeline from "../../assets/Timeline.png";
import { Add, ArrowDownward } from "@mui/icons-material";
import { AppContext } from "../../utils";

import { useStakingContract, useTokenContract } from "../../Connectivity/Hooks";
import { stakingContract as stakingAddress } from "../../Connectivity/environment";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading";
import moment from "moment";
import UnstakeModal from "./UnstakeModal";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { CSVLink } from "react-csv";
// import Reward from "./Reward";

const Staking = () => {
  const matches = useMediaQuery("(max-width:750px)");

  const { account, connect, signer } = useContext(AppContext);
  const stakingContract = useStakingContract(signer);
  const tokenContract = useTokenContract(signer);
  const [index, setIndex] = useState(0);
  const [amount, setAmount] = useState("");
  const [bonus, setBonus] = useState("");
  const [Balance, setBalance] = useState("");
  const [claimed, setClaimed] = useState("");
  const [totalSatakedUser, setTotalSatakedUser] = useState("");
  const [totalStaked, setTotalStaked] = useState("");
  const [totalUnStaked, setTotalUnstaked] = useState("");
  const [loading, setLoading] = useState(false);
  const [stakeDetails, setstakeDetails] = useState([]);
  const [currentStaked, setcurrentStaked] = useState(0);
  const [unstakeModal, setunstakeModal] = useState(false);
  const [unstakeIndex, setunstakeIndex] = useState("");
  const [rewad, setRealTimeReward] = useState("");
  const [staker, setTotalStakers] = useState("");

  // const [totalUnsatkeduser, setTotalUnsatkeduser] = useState("");
  // const [totalWithdrawTokenUser, setTotalWithdrawTokenUser] = useState("");
  const init = async () => {
    try {
      const unsatkePercent = await stakingContract.unstakePercent();
      console.log(unsatkePercent, "===================");

      const bonus = await stakingContract.Bonus(index.toString());
      let bonusToken = (+bonus / +unsatkePercent) * +amount;

      const totalStakedToken = await stakingContract.totalStakedToken();
      const totalUnStakedToken = await stakingContract.totalUnStakedToken();

      const uniqueStaker = await stakingContract.totalStakers();

      setTotalStakers(uniqueStaker.toString());
      // console.log(uniqueStaker.toString(), "jksdfhkjkf");

      setTotalStaked(formatUnits(totalStakedToken.toString(), 18));
      setTotalUnstaked(formatUnits(totalUnStakedToken.toString(), 18));

      setBonus((+amount + bonusToken).toFixed(2));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    init();
  }, [amount, index, account, totalStaked, totalSatakedUser]);

  const inits = async () => {
    try {
      const balance = await tokenContract.balanceOf(account);
      const userdata = await stakingContract.Stakers(account);
      let totalClaimedRewardTokenUser = userdata.totalClaimedRewardTokenUser;
      let totalStakedTokenUser = userdata.totalStakedTokenUser;
      const realReward = await stakingContract.realtimeReward(account);

      setRealTimeReward(+formatUnits(realReward.toString(), 18));

      setBalance(formatUnits(balance.toString(), 18));
      setClaimed(+totalClaimedRewardTokenUser);
      setTotalSatakedUser(formatUnits(totalStakedTokenUser.toString(), 18));
      const { stakeCount } = await stakingContract.Stakers(account);

      if (+stakeCount > 0) {
        let arr = [];
        let currentstaked = 0;
        for (let i = 0; i < +stakeCount; i++) {
          const {
            amount,
            reward,
            withdrawan,
            unstaked,
            staketime,
            withdrawtime,
          } = await stakingContract.stakersRecord(account, i.toString());
          const obj = {
            time: +withdrawtime,
            amount: +formatUnits(amount.toString(), 18),
            reward: +formatUnits(reward.toString(), 18),
            withdrawan: withdrawan,
            unstaked: unstaked,
          };
          if (!unstaked && !withdrawan) {
            currentstaked += +formatUnits(amount.toString(), 18);
          }
          arr.push(obj);
        }
        setcurrentStaked(currentstaked);
        setstakeDetails([...arr]);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    inits();
  }, [account]);

  const stakeHandler = async () => {
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else if (!amount) {
      toast.error("Error! Please enter a amount");
    } else if (amount <= 0) {
      toast.error("Error! Enter valid amount");
    } else {
      try {
        setLoading(true);
        let allowance = await tokenContract.allowance(account, stakingAddress);
        console.log(+allowance, "allowance");
        if (+allowance <= 0) {
          let getAmounts = parseUnits(Balance.toString(), 18);
          const tx = await tokenContract.approve(
            stakingAddress,
            getAmounts.toString()
          );
          await tx.wait();
          toast.success("Success! Approved Confirmed.");
        }

        const tx1 = await stakingContract.stake(
          parseUnits(amount, 18),
          index.toString()
        );
        await tx1.wait();
        toast.success("Success! Transaction Confirmed.");
        setLoading(false);
        init();
        inits();
      } catch (err) {
        setLoading(false);
        if (err?.data?.message) {
          toast.error(err?.data?.message);
        } else {
          toast.error(err?.message);
        }
      }
    }
  };

  const claimHandler = async (index) => {
    console.log(index, "0000");
    try {
      setLoading(true);
      const tx = await stakingContract.withdraw(index.toString(), {
        gasLimit: 21000000,
      });
      await tx.wait();
      toast.success("Success! Amount successfully claimed.");
      inits();
      setLoading(false);
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setLoading(false);
    }
  };
  const Statistics = [
    { name: "JEDSTARS EARN", value: 0 },
    { name: "Your CRDN Wallet Balance", value: Balance },
  ];

  const userInformation = [
    { name: "Claimed Reward", value: claimed },
    { name: "Current Staked", value: totalSatakedUser },
    { name: "Total Staked", value: totalStaked },
    { name: "Total UnSatked", value: totalUnStaked },
  ];

  const currentDate = moment();
  const newDate = currentDate.add(
    index === 0
      ? "7"
      : index === 1
      ? "14"
      : index === 2
      ? "21"
      : index === 3
      ? "30"
      : "60",
    "d"
  );

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({ html: "#my-table" });
    doc.save("my-table.pdf");
  };
  const csvReport = {
    filename: "csvdatafile.csv",
    data: stakeDetails,
  };

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToJson = (e) => {
    downloadFile({
      data: JSON.stringify(stakeDetails),
      fileName: "users.json",
      fileType: "text/json",
    });
  };

  return (
    <Box>
      <UnstakeModal
        open={unstakeModal}
        setOpen={setunstakeModal}
        unstakeIndex={unstakeIndex}
        inits={inits}
      />
      {/* <Reward /> */}
      <Box
        sx={{
          background: `url(${stakinbg}),#0D3B58`,
          backgroundSize: "100% 100%",
          backgroundPosition: { md: "0 0", xs: "center center" },
          height: "auto",
          backgroundRepeat: "no-repeat",
          paddingBottom: "4rem",
        }}
      >
        <Container>
          <Nav />
          <Box>
            <Typography
              varaint="h3"
              sx={{
                fontSize: { xs: "25px", md: "36px" },
                fontWeight: "400",
                fontFamily: "Zen Dots",
                color: "white",
                textAlign: "center",
              }}
            >
              PULSAREX Staking Dashboard
            </Typography>
            <Box display="flex" justifyContent="center" mt={3}>
              <Button
                sx={{
                  my: 2,
                  color: "white",
                  display: "block",
                  fontSize: "1.1rem",
                  padding: "0.9rem 3rem",
                  borderRadius: " 55px;",
                  fontFamily: "Zen Dots",
                  textTransform: "none",
                  background:
                    "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                }}
              >
                Stake puls
              </Button>
            </Box>
            <Box
              py={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="white"
              gap={2}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: "18px", fontFamily: "Josefin Sans" }}
              >
                Powered by
              </Typography>
              <img src={Binance} alt="binance" width="40px" height="40px" />
              <Typography
                variant="h6"
                sx={{ fontSize: "18px", fontFamily: "Josefin Sans" }}
              >
                Binance
              </Typography>
            </Box>

            <Container maxWidth="md">
              <Box mt={6}>
                <Grid
                  container
                  spacing={2}
                  display="flex"
                  justifyContent="center"
                >
                  {[
                    { name: "TOTAL VALUE STAKED", value: totalStaked },
                    { name: "PULS STACKED", value: totalSatakedUser },
                    { name: "UNIQUE STAKERS", value: staker },
                    { name: "PULS-LP STAKED", value: totalSatakedUser },
                    { name: "AVAERAGE APY", value: "41.0%" },
                  ].map(({ name, value }, i) => {
                    return (
                      <Grid item md={4} sm={6} xs={12} key={i}>
                        <Box display="flex" justifyContent="center">
                          <Box
                            sx={{
                              background: `url(${discard})`,
                              backgroundSize: "100% 100%",
                              backgroundRepeat: "no-repeat",
                              height: { sm: "150px", xs: "200px" },
                              width: { sm: "100%", xs: "250px" },
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {name ? name : "0"}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {value ? value : "0"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>

                {/* ------------------------------PULSAREX Calculator----------------------------------- */}

                <Box mt={10}></Box>
                <Typography
                  varaint="h3"
                  sx={{
                    fontSize: { xs: "25px", md: "36px" },
                    fontWeight: "400",
                    fontFamily: "Zen Dots",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  PULSAREX Calculator
                </Typography>
                <Box
                  sx={{
                    marginTop: "2rem",
                    background: `url(${bgframe})`,
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat !important",
                    padding: { md: "2rem", xs: "1rem" },
                    textAlign: "center",
                  }}
                >
                  <Loading loading={loading} />

                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      fontSize: { md: "16px", xs: "14px" },
                      fontWeight: "400",
                      color: "rgba(255, 255, 255, 1)",
                    }}
                  >
                    Calculate your PULSREX depending on the amount of staked
                    tokens and your lock time.
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      fontSize: { md: "16px", xs: "14px" },
                      fontWeight: "400",
                      color: "rgba(255, 255, 255, 1)",
                      display: { md: "block", xs: "none" },
                    }}
                  >
                    tokens and your lock time.
                  </Typography>
                  <Box
                    mt={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: { md: 10, xs: 4 },
                    }}
                  >
                    <Typography
                      varaint="h3"
                      sx={{
                        fontSize: { md: "20px", xs: "12" },
                        fontWeight: "400",
                        fontFamily: "Zen Dots",
                        color: "white",
                        textAlign: "left !important",
                        marginLeft: { md: "-8rem", xs: "1rem" },
                      }}
                    >
                      PULS
                    </Typography>
                    <TextField
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      placeholder="5000"
                      type="number"
                      InputLabelProps={{
                        style: { color: "white" },
                      }}
                      sx={{ width: { xs: "100%", sm: "100%", md: "30%" } }}
                      InputProps={{
                        sx: {
                          background: "white",
                          color: "black",

                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "none",
                            color: "black",
                          },
                        },
                      }}
                    />
                  </Box>
                  <Add
                    style={{
                      textAlign: "center",
                      margin: "0.5rem 0",
                      color: "white",
                      fontWeight: "400",
                      fontSize: "35px",
                    }}
                  />
                  <Typography
                    variant="h6"
                    mb={3}
                    sx={{
                      fontSize: "15px",
                      fontWeight: "400",
                      fontFamily: "Zen Dots",
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    Lock Token For Days
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="space-around"
                    flexWrap="wrap"
                  >
                    <Button
                      sx={{
                        my: 2,
                        color: index === 0 ? "#50E1F2" : "white",
                        display: "block",
                        fontSize: "1.1rem",
                        borderRadius: " 10px;",
                        fontFamily: "Zen Dots",
                        textTransform: "none",
                        background:
                          index === 0
                            ? "White"
                            : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        "&:hover": {
                          background:
                            index === 0
                              ? "White"
                              : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        },
                      }}
                      onClick={() => setIndex(0)}
                    >
                      7 days
                    </Button>
                    <Button
                      sx={{
                        my: 2,
                        color: index === 1 ? "#50E1F2" : "white",
                        display: "block",
                        fontSize: "1.1rem",
                        borderRadius: " 10px;",
                        fontFamily: "Zen Dots",
                        textTransform: "none",
                        background:
                          index === 1
                            ? "White"
                            : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        "&:hover": {
                          background:
                            index === 1
                              ? "White"
                              : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        },
                      }}
                      onClick={() => setIndex(1)}
                    >
                      14 days
                    </Button>
                    <Button
                      sx={{
                        my: 2,
                        color: index === 2 ? "#50E1F2" : "white",
                        display: "block",
                        fontSize: "1.1rem",
                        borderRadius: " 10px;",
                        fontFamily: "Zen Dots",
                        textTransform: "none",
                        background:
                          index === 2
                            ? "White"
                            : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        "&:hover": {
                          background:
                            index === 2
                              ? "White"
                              : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        },
                      }}
                      onClick={() => setIndex(2)}
                    >
                      21 days
                    </Button>
                    <Button
                      sx={{
                        my: 2,
                        color: index === 3 ? "#50E1F2" : "white",
                        display: "block",
                        fontSize: "1.1rem",
                        borderRadius: " 10px;",
                        fontFamily: "Zen Dots",
                        textTransform: "none",
                        background:
                          index === 3
                            ? "White"
                            : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        "&:hover": {
                          background:
                            index === 3
                              ? "White"
                              : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        },
                      }}
                      onClick={() => setIndex(3)}
                    >
                      30 days
                    </Button>
                    <Button
                      sx={{
                        my: 2,
                        color: index === 4 ? "#50E1F2" : "white",
                        display: "block",
                        fontSize: "1.1rem",
                        borderRadius: " 10px;",
                        fontFamily: "Zen Dots",
                        textTransform: "none",
                        background:
                          index === 4
                            ? "White"
                            : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        "&:hover": {
                          background:
                            index === 4
                              ? "White"
                              : "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        },
                      }}
                      onClick={() => setIndex(4)}
                    >
                      60 days
                    </Button>
                  </Box>
                  <ArrowDownward
                    style={{
                      textAlign: "center",
                      margin: "0.5rem 0",
                      color: "white",
                      fontWeight: "400",
                      fontSize: "35px",
                    }}
                  />
                  <Box
                    mt={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: { md: 10, xs: 2 },
                    }}
                  >
                    <Typography
                      varaint="h3"
                      sx={{
                        fontSize: { md: "20px", xs: "12px" },
                        fontWeight: "400",
                        fontFamily: "Zen Dots",
                        color: "white",
                        textAlign: "left !important",
                        marginLeft: { md: "-12rem", xs: "1rem" },
                      }}
                    >
                      $PULSREX
                    </Typography>
                    <TextField
                      value={bonus}
                      placeholder="5000"
                      type="number"
                      InputLabelProps={{
                        style: { color: "white" },
                      }}
                      sx={{ width: { xs: "100%", sm: "100%", md: "30%" } }}
                      InputProps={{
                        sx: {
                          background: "white",
                          color: "black",

                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "none",
                            color: "black",
                          },
                        },
                      }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      marginTop: "1rem",
                      fontSize: "15px",
                      fontWeight: "400",
                      fontFamily: "Zen Dots",
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    locked until {newDate.format("DD-MM-YYYY")}
                  </Typography>
                  <Box display="flex" justifyContent="center" mt={3}>
                    {account ? (
                      <Button
                        sx={{
                          my: 2,
                          color: "white",
                          display: "block",
                          fontSize: "1.1rem",
                          padding: { sm: "0.9rem 4.5rem", xs: "0.9rem 1.5rem" },
                          borderRadius: " 55px;",
                          fontFamily: "Zen Dots",
                          textTransform: "none",
                          background:
                            "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        }}
                        onClick={() => stakeHandler()}
                      >
                        Stake
                      </Button>
                    ) : (
                      <Button
                        sx={{
                          my: 2,
                          color: "white",
                          display: "block",
                          fontSize: "1.1rem",
                          padding: { sm: "0.9rem 4.5rem", xs: "0.9rem 1.5rem" },
                          borderRadius: " 55px;",
                          fontFamily: "Zen Dots",
                          textTransform: "none",
                          background:
                            "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                        }}
                        onClick={() => connect()}
                      >
                        Connect Wallet
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>

              {/* ------------------------------ Your Statistics----------------------------------- */}

              <Box py={5}>
                <Typography
                  varaint="h3"
                  sx={{
                    fontSize: { xs: "25px", md: "36px" },
                    fontWeight: "400",
                    fontFamily: "Zen Dots",
                    color: "white",
                    textAlign: "center",
                    marginBottom: "2rem",
                  }}
                >
                  Your Statistics
                </Typography>
                <Grid container spacing={2}>
                  {Statistics.map(({ name, value }, i) => {
                    return (
                      <Grid item sm={6} xs={12} key={i}>
                        <Box display="flex" justifyContent="center">
                          <Box
                            sx={{
                              background: `url(${discard})`,
                              backgroundSize: "100% 100%",
                              backgroundRepeat: "no-repeat",
                              height: { sm: "150px", xs: "200px" },
                              width: { sm: "100%", xs: "250px" },
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {name ? name : "0"}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {value ? value : "0"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                  {userInformation.map(({ name, value }, i) => {
                    return (
                      <Grid item md={3} sm={6} xs={12} key={i}>
                        <Box display="flex" justifyContent="center">
                          <Box
                            sx={{
                              background: `url(${discard})`,
                              backgroundSize: "100% 100%",
                              backgroundRepeat: "no-repeat",
                              height: { sm: "150px", xs: "200px" },
                              width: { sm: "100%", xs: "250px" },
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {name ? name : "0"}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontWeight: "400",
                                fontFamily: "Zen Dots",
                                color: "#D9D9D9",
                                textAlign: "center",
                              }}
                            >
                              {value ? value : "0"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
              {/* ------------------------------ jedstar----------------------------------- */}

              <Typography
                varaint="h3"
                sx={{
                  fontSize: { xs: "25px", md: "36px" },
                  fontWeight: "400",
                  fontFamily: "Zen Dots",
                  color: "white",
                  textAlign: "center",
                  marginBottom: "2rem",
                }}
              >
                JEDSTAR
              </Typography>

              <Box display="flex " justifyContent="center" gap={2}>
                <Button variant="contained" onClick={() => exportPDF()}>
                  Export to pdf
                </Button>
                <Button variant="contained">
                  <CSVLink
                    {...csvReport}
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Download Csv
                  </CSVLink>
                </Button>
                <Button variant="contained" onClick={() => exportToJson()}>
                  Download Json
                </Button>

                {/* <Button variant="contained">Export to xls</Button> */}
              </Box>

              <Box>
                {/* <Grid container spacing={2}>
                  {["Staked Amount", "Withdrawal Time", "UnStake", "Claim"].map(
                    (item, i) => {
                      return (
                        <Grid item md={3} sm={6} xs={12} key={i}>
                          <Box display="flex" justifyContent="center">
                            <Box
                              sx={{
                                background: `url(${discard})`,
                                backgroundSize: "100% 100%",
                                backgroundRepeat: "no-repeat",
                                height: { sm: "150px", xs: "200px" },
                                width: { sm: "100%", xs: "250px" },
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  fontFamily: "Zen Dots",
                                  color: "#D9D9D9",
                                  textAlign: "center",
                                }}
                              >
                                {item}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "24px",
                                  fontWeight: "400",
                                  fontFamily: "Zen Dots",
                                  color: "#D9D9D9",
                                  textAlign: "center",
                                }}
                              >
                                0
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      );
                    }
                  )}
                </Grid> */}
              </Box>
              {/* ------------------------------------------------------------------------- */}
              <Box>
                <TableContainer
                  // borderTop="1px solid #F7C35F"
                  // borderBottom="10px solid #F7C35F"
                  // borderLeft="1px solid #668056"
                  // borderRight="1px solid #668056"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "transparent",

                    backgroundClip: "content-box, border-box",
                    padding: "4px",
                  }}
                  filter="blur(52px)"
                  zIndex="10"
                  pt={2}
                  pb={5}
                  mt={2}
                  className="shadow"
                  // borderRadius="20px"
                  component={Box}
                  color="#fff"
                >
                  <Table
                    id="my-table"
                    aria-label="simple table"
                    style={{
                      borderRadius: "10px",
                      marginTop: "0px",
                    }}
                    color="#fff"
                  >
                    <TableHead color="#fff">
                      <TableRow style={{ color: "#fff" }}>
                        <TableCell
                          align="center"
                          style={{
                            color: "#fff",
                            fontSize: matches ? "14px" : "18px",
                            fontFamily: "Expletus Sans",
                          }}
                        >
                          AMOUNT{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            color: "#fff",
                            fontSize: matches ? "14px" : "18px",
                            fontFamily: "Expletus Sans",
                          }}
                        >
                          WITHDRAWAL TIME
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            color: "#fff",
                            fontSize: matches ? "14px" : "18px",
                            fontFamily: "Expletus Sans",
                          }}
                        >
                          UNSTAKE{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            color: "#fff",
                            fontSize: matches ? "14px" : "18px",
                            fontFamily: "Expletus Sans",
                          }}
                        >
                          WITHDRAWAL
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stakeDetails.length > 0 ? (
                        stakeDetails.map(
                          ({ time, amount, withdrawan, unstaked }, index) => (
                            <TableRow
                              key={index}
                              style={{ borderBottom: "1px solid red" }}
                            >
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Expletus Sans",
                                }}
                              >
                                {amount}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Expletus Sans",
                                }}
                              >
                                {moment.unix(time).format("LLL")}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                  fontSize: matches ? "14px" : "18px",
                                  fontFamily: "Expletus Sans",
                                }}
                              >
                                <Box display="flex" justifyContent="center">
                                  <Button
                                    onClick={() => {
                                      setunstakeModal(true);
                                      setunstakeIndex(index.toString());
                                    }}
                                    disabled={
                                      +time < +moment().format("X") ||
                                      withdrawan ||
                                      unstaked
                                        ? true
                                        : false
                                    }
                                    sx={{
                                      my: 2,
                                      color: "white",
                                      display: "block",
                                      background:
                                        "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                                    }}
                                  >
                                    Unstake
                                  </Button>
                                </Box>
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Box display="flex" justifyContent="center">
                                  <Button
                                    onClick={() =>
                                      claimHandler(index.toString())
                                    }
                                    disabled={
                                      +time > +moment().format("X") ||
                                      withdrawan ||
                                      unstaked
                                        ? true
                                        : false
                                    }
                                    sx={{
                                      my: 2,
                                      color: "white",
                                      display: "block",
                                      background:
                                        "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                                    }}
                                  >
                                    Withdraw
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      ) : loading ? (
                        loading
                      ) : (
                        <TableRow>
                          <TableCell
                            align="center"
                            style={{
                              color: "#fff",
                              fontSize: matches ? "14px" : "18px",
                              fontFamily: "Expletus Sans",
                              fontFamily: "Expletus Sans",
                            }}
                            colSpan={5}
                          >
                            You have no staking history yet
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Container>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Staking;
